<template>
<div>
  <div style="height: 40px;padding-top: 20px;margin: 0 20px">
    <el-button size="small" type="primary" @click="addBtn">新增</el-button>
    <el-date-picker v-fixZoom size="small" :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
    </el-date-picker>
    <el-button size="small" type="success" @click="searchBtn">查询</el-button>
  </div>
  <div style="max-height: 350px;margin: 0 20px;overflow-y: auto">
    <el-table size="mini" :data="tableData" border highlight-current-row ref="singleTable">
      <el-table-column
        type="index"
        label="序号"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        label="项目名称"
        min-width="90"
        align="center">
        <template slot-scope="scope">
          <span>{{ getProjectName(scope.row.project_id) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="扣费顺序"
        width="90"
        align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.project_order === 1">周期前扣费</span>
          <span v-if="scope.row.project_order === 2">周期后扣费</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="change_time"
        label="变动时间"
        min-width="100"
        align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
          <i title="终止" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 10px;height: 40px;text-align: center">
    <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                   :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                   layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
  <el-dialog width="600px" :title="titleName" :visible.sync="addEditShow" v-if="addEditShow" append-to-body center>
    <add-edit-set-project :projectRow="projectRow" v-model="addEditShow" @updateTable="updateTable"></add-edit-set-project>
  </el-dialog>
</div>
</template>

<script>
import {queryelderlyfinanceproject, queryfinanceproject, deleteelderlyfinanceproject} from '../../../api/yanglaoyuan'
import addEditSetProject from './addEditSetProject'
export default {
  name: 'setProject',
  components: {addEditSetProject},
  props: {
    oldPersonObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      titleName: '设置项目',
      addEditShow: false,
      projectRow: {
        isAdd: true,
        row: '',
        billRow: '',
        financeProject: ''
      }
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-7)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getTimeObj()
    this.getProjectData()
    this.projectRow.billRow = this.oldPersonObj.row
  },
  methods: {
    // 收费项目
    getProjectData () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.$store.state.user.LoginResp.entity_id
      }
      queryfinanceproject(params, data).then(res => {
        this.projectRow.financeProject = res.data.financeProject
        this.queryDataTable()
      }).catch(() => {})
    },
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    },
    searchBtn () {
      this.queryDataTable()
    },
    updateTable () {
      this.queryDataTable()
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.oldPersonObj.row.eid,
        epid: this.oldPersonObj.row.epid,
        change_time_from: this.sendDate[0] + ' 00:00:00',
        change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinanceproject(params, data).then(res => {
        this.tableData = res.data.elderlyFinanceProject
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    addBtn () {
      this.titleName = this.oldPersonObj.row.elderly_name + ' - 设置项目'
      this.projectRow.isAdd = true
      this.projectRow.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.titleName = this.oldPersonObj.row.elderly_name + ' - 编辑项目'
      this.projectRow.isAdd = false
      this.projectRow.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除老人该收费项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteelderlyfinanceproject(data).then(res => {
          this.$notify({title: '成功', message: '成功删除床位', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    getProjectName (projectid) {
      let name = projectid
      let arr = this.projectRow.financeProject
      for (let i = 0; i < arr.length; i++) {
        if (projectid === arr[i].id) {
          name = arr[i].project_name
        }
      }
      return name
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/setProject.vue